import http from '@/utils/http.js'
/*
 * @DESC:api接口
 */
const 	GET_KEYWORDS = "/api/getKeywordsList", //获取关键词
		SAVE_KEYWORDS = "/api/saveKeywords", //保存关键词
		DEL_KEYWORDS = "/api/deleteKeywords" //删除关键词

export default {
	getKeywordsList: async({
		commit
	}, params={}) => {
		const data = await http.get(GET_KEYWORDS,params)
		commit('GET_KEYWORDS', data)
	},
	saveKeywords: ({
		commit
	}, params={}) => {
		return http.post(SAVE_KEYWORDS,params)
	},
	deleteKeywords: ({
		commit
	}, params={}) => {
		return http.post(DEL_KEYWORDS,params)
	}
}


// WEBPACK FOOTER //
// ./src/store/mp/wechat/keywords/actions.js